

















































import {Vue, Component, Watch} from 'vue-property-decorator';
import SearchStore from '@/store/SearchStore.brain';
import DetailStore from '@/store/DetailStore';
import ForceGraph from './force-graph.vue';
import ForceGraphControl from './force-graph-control.vue';
import PoiLeft from './poi-left.vue';
import PoiRight from './poi-right.vue';
import BrainSearch from './brain-search.vue';
import RightPerson from './user/right-person.vue';

@Component({
    components: {ForceGraph, ForceGraphControl, PoiLeft, PoiRight, BrainSearch, RightPerson}
})
export default class BrainContent extends Vue {
    name: 'BrainContent';
    searchData = SearchStore.state;
    detailData = DetailStore.state;
    get entityType() {return this.searchData.searchItem.entityType}
    get detailDataR() {return this.detailData}
    get userData() {return this.detailData.userData}
    get poiData() {return this.detailData.poiData}
    get poiGraph() {return this.detailData.poiGraph}
    get userGraph() {return this.detailData.userGraph}
    get graphInfo() {return this.detailData.graphInfo}
    get loading() {return this.detailData.loading}
    cancelToken: any;
    aef: any;
    animationStatus = autoAnimation ? 'fly-out' : 'fly-in'; // normal fly-out fly-in
    isShowComplete: any = false;

    *actionScriptContent (isQuick, type) {
        // 优先判断左右两侧是否需要动画
        if (type) {
            this.animationStatus = 'fly-in';
            yield this.$sleep(0); // hack 后续要跟进
            yield Promise.all([
                this.$bus.$emit('poi-left-start'),
                this.$bus.$emit('poi-right-start'),
            ]);
            return void 0;
        }
        // 然后判断是否快速方式
        if (isQuick) {
            this.animationStatus = 'fly-in';
            this.$bus.$emit('poi-left-start', isQuick);
            this.$bus.$emit('poi-right-start', isQuick);
            this.isShowComplete = true;
            return void 0;
        }

        // yield this.$bus.$emit('force-graph-animation'); // 调试中间图谱动画用的

        this.animationStatus = 'fly-in';
        yield this.$sleep(0); // hack 后续要跟进
        // yield this.$onNativeOnce('this.$refs.brainContentLeft'); // 左右一起进来

        yield Promise.all([
            this.$bus.$emit('poi-left-start'),
            this.$bus.$emit('poi-right-start'),
        ]);

        if (window['_screenType'] === '2160') {
            yield this.$sleep(1000);
            this.animationStatus = 'fly-out';
            yield this.$onNativeOnce('this.$refs.brainContentLeft');
            yield this.$sleep(2000);
        } else {
            this.animationStatus = 'fly-out';
            yield this.$onNativeOnce('this.$refs.brainContentLeft');
            yield this.$sleep(2000);
        }
        yield this.$bus.$emit('force-graph-animation');
        this.isShowComplete = true;
    }

    created () {
        if ($qsObj.force === 'true') {
            this.animationStatus = 'fly-out';
        }
    }

    mounted () {
        console.log('mounted:BrainContent');
        this.cancelToken = new this.$ae.CancelToken();
        this.aef = this.$ae(this.actionScriptContent, this.cancelToken);
        this.$autoOn('brain-content', this.aef);

        // 左右侧展开收起
        this.$autoOn('force-RightLeft-out', async (str = 'fly-out') => {
            this.animationStatus = this.animationStatus === 'fly-in' ? 'fly-out' : 'fly-in';
            await this.$onNativeOnce('this.$refs.brainContentLeft');
        });

        this.$autoOn('force-RightLeft-fly', async (str = 'fly-out') => {
            this.animationStatus = str;
            await this.$onNativeOnce('this.$refs.brainContentLeft');
        });

        // TODO 复位
        this.$autoOn('action-script-stop', () => {
            // debugger;
            console.log('this.isShowComplete', this.isShowComplete);

            this.cancelToken.abort();
            if ($qsObj.force === 'true') {return void 0;} // 特殊模式下 恢复不了的
            // this.animationStatus = 'fly-in'; // 保持此时此刻的模样
            if (!this.isShowComplete) {
                this.$bus.$emit('poi-left-start', true);
                this.$bus.$emit('poi-right-start', true);
                this.isShowComplete = true;
            }
        });
        this.$autoOn('action-script-start', () => {
            this.cancelToken = null;
            this.$bus.$emit('view-change', '2d', '3d');
        });
    }

    destroyed () {

    }
}
